// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-result[data-v-553df2bc]{width:100%;padding:100px 0;text-align:center;font-family:Igra Sans,sans-serif}.empty-result .title[data-v-553df2bc]{display:block;font-weight:500;font-size:26px;line-height:32px;text-transform:uppercase;margin:0}", ""]);
// Exports
module.exports = exports;
